<ng-template #dynAuditTrailPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAuditPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{auditTrail.report_And_Popup_Name}} </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>

    <div class="tab">
        <mat-tab-group class="activitytab mat-tab-container mat-elevation-z4" animationDuration="0ms"
            (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex">
            <mat-tab label="Activity">
                <ng-template mat-tab-label>
                    <span>
                        <i class='fa fa-tasks' style="font-size: 18px;" aria-hidden="true"></i>
                    </span>&nbsp;<span>Activity</span>
                </ng-template>
                <div class="position-relative" *ngIf="selectedTabIndex == 0">
                    <div>
                        <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-center px-3">
                                <div class="dropdown">
                                </div>
                            </div>
                            <div class="d-flex gap-3">
                                <div id="header-container">
                                    <div class="">
                                        <div class="search-container">
                                            <span class="fa fa-search form-control-feedback"></span>
                                            <input type="text" class="form-control search_input" style="font-size: 12px"
                                                placeholder="Search here..." [(ngModel)]="searchValue"
                                                (input)="applyFilter2($event)" />
                                        </div>
                                    </div>
                                </div>
                                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                                    (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
                                    <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                                    <span class="reload_text text-white">Excel Report</span>
                                </div>
                                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                                    (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                                    <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                                    <span class="reload_text text-white">PDF Report </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="table-container">
                        <table class="dynamic-table-container" aria-describedby="table-description"
                            style="max-height: 60vh !important;">
                            <thead>
                                <th style="min-width: 60px; text-align: center;"
                                    [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                                    <div style="display: flex;">
                                        <div>
                                            <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                                        </div>
                                    </div>
                                </th>
                                <th class="grid-header-container"
                                    *ngFor="let columnData of columnLists.fieldColumnarray; let ix = index;" [ngStyle]="{'min-width': columnData.width,'max-width': columnData.width,'overflow': 'hidden',
                                    'text-overflow': 'ellipsis',
                                    'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssFunction(0)"
                                    (focus)="onFocusEmpty()">
                                    <div
                                        class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                                        <span>{{ columnData.fieldColumnarray }}</span>
                                        <div class="d-flex gap-2 align-items-center">
                                            <div (click)="sortColumn(columnLists.columnsListarray[ix],columnData)"
                                                (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],columnData)">
                                                <img src="../../../assets/img/qms_img/sort.svg" width="9px"
                                                    height="16px" alt="sort" />
                                            </div>
                                        </div>
                                    </div>
                                </th>
                                <th id="menu" class="sticky-col first-col"></th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                                    </td>
                                    <td *ngFor=" let columnData of columnLists.fieldColumnarray; let ix = index "
                                        [ngStyle]="{ 'min-width': columnData.width != null ? columnData.width : '200px' }"
                                        class="sticky-dynamic-col1" (mouseover)="cssFunction(0)"
                                        (focus)="onFocusEmpty()">
                                        <div class="row-search-container"><input type="text" class="form-control"
                                                placeholder="Search"
                                                (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" />
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngFor="let list of pagedItems let idx = index;">
                                    <td style="min-width: 60px; text-align: center;"
                                        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                                        <div style="display: flex;">
                                            <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                                                <i class="fa-solid fa-ellipsis-vertical"></i>
                                            </div>
                                            <div>
                                                <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBox"
                                                    (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                                            </div>
                                        </div>
                                    </td>
                                    <td *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                                        class="sticky-dynamic-row1" (mouseover)="cssFunction(i)"
                                        (focus)="onFocusEmpty()"
                                        [ngClass]="list.differColumn.includes(key.columnsListarray) ?'audit-bg-highlight':''"
                                        [ngStyle]="{'min-width': key.width !=null ? key.width[i] :'200px','max-width': key.width !=null ? key.width[i] :'200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                                        <span *ngIf="key.dataType=='CHECKBOX'">
                                            <div class="gridCheckBoxes">
                                                <img *ngIf="list[key.columnsListarray]"
                                                    src="../../assets/img/accessSymbol.svg" alt="Yes" width="20"
                                                    height="20">
                                                <img *ngIf="list[key.columnsListarray]==false"
                                                    src="../../assets/img/noAcessSymbol.svg" alt="No" width="20"
                                                    height="20">
                                            </div>
                                        </span>

                                        <span
                                            *ngIf="list[key.columnsListarray]=='fileIspresentsa' || list[key.columnsListarray]=='fileIsNotpresentsa'">
                                            <div class="download-button-continer btn-align" mat-dialog-actions>
                                                <button class="d-flex align-items-center" mat-stroked-button
                                                    class="downloadButton"
                                                    (click)="downloadDocuments(list,key.columnsListarray)">
                                                    <img src="../../../assets/img/cr_module/download.svg" width="12px"
                                                        height="12px" alt="download">
                                                    <span class="ms-1">View</span>
                                                </button>
                                            </div>
                                        </span>

                                        <span
                                            *ngIf="list[key.columnsListarray]=='htmlClobView' || list[key.columnsListarray]=='htmlClobView'">
                                            <div class="download-button-continer btn-align" mat-dialog-actions>
                                                <button class="d-flex align-items-center" mat-stroked-button
                                                    class="downloadButton"
                                                    (click)="getClobData(list,key.columnsListarray)">
                                                    <img src="../../../assets/img/cr_module/download.svg" width="12px"
                                                        height="12px" alt="download">
                                                    <span class="ms-1">View</span>
                                                </button>
                                            </div>
                                        </span>
                                        <span
                                            *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'  && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' && key.columnsListarray!='TEMPLATE'">
                                            {{
                                            list[key.columnsListarray] === 'U' ? 'Updated' :
                                            list[key.columnsListarray] === 'ID' ? 'Created and Deleted' :
                                            list[key.columnsListarray] === 'UD' ? 'Updated and Deleted' :
                                            list[key.columnsListarray] === 'I' ? 'Created' :
                                            list[key.columnsListarray]
                                            }}
                                        </span>
                                        <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
                                        <span
                                            *ngIf=" key.columnsListarray=='TEMPLATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">
                                            <div class=" download-button-continer btn-align" mat-dialog-actions>
                                                <button mat-stroked-button class="downloadButton"
                                                    (click)="downloadDocuments(list,key.columnsListarray)">
                                                    <i class="fa-solid fa-download"></i> View
                                                </button>
                                            </div>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="d-flex justify-content-center">
                            <div class="width-cheat small paginationCell">
                                <div class="d-flex align-items-center gap-3">
                                    <div class="pagination_text mt-3">
                                        {{ showingRowsText }}
                                        1-{{ perPage }} of {{ collectionSize | number }}
                                    </div>
                                    <div>
                                        <ngb-pagination class="leftpadding"
                                            (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                                            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                                            [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                                            [boundaryLinks]="true" size="sm">
                                        </ngb-pagination>
                                    </div>
                                    <div ngbDropdown class="mt-3">
                                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text"
                                            class="dropdownBasic1" ngbDropdownToggle>
                                            {{ perPage }}
                                            <i class="ms-1 fa-solid fa-chevron-down"></i>
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                                            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                                            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                                        </div>
                                        per page
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Additional Details">
                <ng-template mat-tab-label>
                    <span>
                        <i class='fa fa-plus' style="font-size: 18px;" aria-hidden="true"></i>
                    </span>&nbsp;<span>Additional Details</span>
                </ng-template>

                <div class="table-container">
                    <table class="dynamic-table-container" style="max-height: 60vh; margin:3px;">
                        <thead>
                            <th class="grid-header-container" *ngFor="let f of headers; let idx = index;"
                                [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                                    <span>{{f}}</span>
                                </div>
                            </th>
                        </thead>
                        <tbody *ngFor="let f of pagedItemsFlexi;">
                            <td class="sticky-dynamic-row1" *ngFor="let r of f;"
                                [ngStyle]="{'background-color': r.updated == 'Y' ? 'yellow' : '', 
                                'min-width': '100px', 'max-width': '300px', 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                                [matTooltip]="r.value" matTooltipPosition="below" [matTooltipShowDelay]="300"
                                [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip">
                                {{r.value}} </td>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex justify-content-center">
                    <div class="width-cheat small paginationCell">
                        <div class="d-flex align-items-center gap-3">
                            <div class="pagination_text mt-3">
                                {{ showingRowsText }}
                                1-{{ perPage }} of {{ collectionSize | number }}
                            </div>
                            <div>
                                <ngb-pagination class="leftpadding"
                                    (pageChange)="setPageFlexi(pager.currentPage, $event)" [disabled]="false"
                                    [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize"
                                    [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true"
                                    size="sm">
                                </ngb-pagination>
                            </div>
                            <div ngbDropdown class="mt-3">
                                <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text"
                                    class="dropdownBasic1" ngbDropdownToggle>
                                    {{ perPage }}
                                    <i class="ms-1 fa-solid fa-chevron-down"></i>
                                </button>
                                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                    <button ngbDropdownItem (click)="paginationCallFlexi(10)">10</button>
                                    <button ngbDropdownItem (click)="paginationCallFlexi(20)">20</button>
                                    <button ngbDropdownItem (click)="paginationCallFlexi(50)">50</button>
                                </div>
                                per page
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="noData && !isProcessing"
                    style="text-align: center; margin: 10px; font-size: large; color: red;">
                    No Data
                </div>
            </mat-tab>

            <mat-tab label="Switched Users">
                <ng-template mat-tab-label>
                    <span>
                        <i class='fa fa-user' style="font-size: 18px;" aria-hidden="true"></i>
                    </span>&nbsp;<span>Switched Users</span>
                </ng-template>
                <div class="position-relative">
                    <div>
                        <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-center px-3">
                                <div class="dropdown">
                                </div>
                            </div>
                            <div class="d-flex gap-3">
                                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                                    (click)="openStaticReportPopup('Excel')"
                                    (keydown.enter)="openStaticReportPopup('Excel')">
                                    <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                                    <span class="reload_text text-white">Excel Report</span>
                                </div>
                                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                                    (click)="openStaticReportPopup('Pdf')"
                                    (keydown.enter)="openStaticReportPopup('Pdf')">
                                    <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                                    <span class="reload_text text-white">PDF Report </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-container" *ngIf="switchUserLog.length && !isProcessing">
                    <table style="max-height: 45vh;">
                        <thead>
                            <th class="grid-header-container"
                                [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                                    <span>User Role</span>
                                </div>
                            </th>

                            <th class="grid-header-container"
                                [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                                    <span>Switched From</span>
                                </div>
                            </th>

                            <th class="grid-header-container"
                                [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                                    <span>Switched To</span>
                                </div>
                            </th>

                            <th class="grid-header-container"
                                [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                                    <span>Switched By</span>
                                </div>
                            </th>

                            <th class="grid-header-container"
                                [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                                    <span>Switched at Status</span>
                                </div>
                            </th>

                            <th class="grid-header-container"
                                [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                                    <span>Reason for Switch</span>
                                </div>
                            </th>

                            <th class="grid-header-container"
                                [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                                    <span>Switched On</span>
                                </div>
                            </th>

                            <th class="sticky-col first-col"></th>
                        </thead>
                        <tbody>
                            <tr class="data-row-container" *ngFor="let switch of switchUserLog; let idx = index;">
                                <td class="row-data">{{ switch.userRole }}</td>
                                <td class="row-data">{{ switch.switchedFromUser }}</td>
                                <td class="row-data">{{ switch.switchedToUser }}</td>
                                <td class="row-data">{{ switch.switchedByUser }}</td>
                                <td class="row-data">{{ switch.status }}</td>
                                <td class="row-data">{{ switch.reasonForSwitch }}</td>
                                <td class="row-data">{{ switch.createdOnStr }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="!switchUserLog.length && !isProcessing"
                    style="text-align: center; margin: 10px; font-size: large; color: red;">
                    No Data
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

</ng-template>


<ng-template #excelPdfPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="center">
        <label for="email" style="font-size: medium; font-weight: bold;">
            Do you want to generate {{ popupDataTitle.title }} ?</label>
    </div>
    <div style="margin: 15px 15px;" class="center" *ngIf="!isForExcel">
        <label for="email" style="font-size: .7rem; font-weight: bold;">
            <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
            <span *ngIf="manuallyPicked && maxCountReached">
                We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
            </span>
        </label>
    </div>

    <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
        <div class="col-md-12" *ngIf="selectedColumns.length">
            <div><label for="email">Selected Column(s)</label></div>
            <textarea id="selectedValuesTextarea" class="input-filed-textarea"
                style="margin-top: 8px; cursor: not-allowed;" rows="4" cols="50" [disabled]="true"
                [(ngModel)]="selectedColumnsAsString"></textarea>
        </div>

        <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
            <div class="col-md-6">
                <label for="radio">PDF Page Size</label>
                <mat-radio-group [(ngModel)]="pdfPageSize">
                    <mat-radio-button *ngFor="let data of pdfPageSizes"
                        [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-md-6" style="margin-top: 1.5%;">
                <label for="toggle">Pick Columns Manually?</label>&nbsp;
                <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked"
                    id="toggle">
                    <ng-container *ngIf="manuallyPicked; else no">
                        <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                    </ng-container>
                    <ng-template #no>
                        <span style="color: red;">No</span>
                    </ng-template>
                </mat-slide-toggle>
            </div>
        </div>

        <div class="row mt-3" *ngIf="manuallyPicked">
            <div class="col-md-12">
                <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
                <mat-select matInput multiple placeholder="Select" #columns [(ngModel)]="selectedColumns"
                    (closed)="columnSearchText=''" (click)="focusSearch('focus-column-search')"
                    (keydown.enter)="focusSearch('focus-column-search')">
                    <input type="search" id="focus-column-search" class="dropdownsearchstyle"
                        [(ngModel)]="columnSearchText" matInput placeholder="search">
                    <div class="select-all">
                        <mat-checkbox [(ngModel)]="isAllColumns" (change)="toggleAllSelection('columns')">
                            Select All</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let item of dropDownForReport | multiAssessmentSearchPipe : columnSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
    </div>

    <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="generateReport(isForExcel ? 'Excel' : 'Pdf')">
            <i class="fa fa-file-excel-o"></i> Generate
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #viewerPdfPopup>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div id="viewerHideShow" #viewer style="height: 96%; margin-top: 5px"></div>
</ng-template>

<ng-template #viewerimagePopup>
    <button class="close close-button" (click)="cancelAddAndEditFunctionimage()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div class="row" style="padding:5px;">
        <div class="col-sm-12">
            <img id="picturewe" src="" height="85vh" width="100%" alt="view"
                style="overflow: hidden; height: 85vh; width: 100%" />
        </div>
    </div>
</ng-template>

<ng-template #viwertextPopup>
    <button class="close close-button" (click)="cancelAddAndEditFunctionimage()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div class="row" style="padding:5px;">
        <st-editor [(ngModel)]="extension" [config]="config" [disabled]="!extension"
            placeholder="Add Description"></st-editor>
    </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>